export const SHOPPING_LIST_POPUP_PREFIX = "ShoppingListPopup";

export const SHOPPING_LIST_POPUP_CLASSES = {
  popup: `${SHOPPING_LIST_POPUP_PREFIX}-popup`,
  popupTitleWrap: `${SHOPPING_LIST_POPUP_PREFIX}-popupTitleWrap`,
  title: `${SHOPPING_LIST_POPUP_PREFIX}-title`,
  descriptionWrap: `${SHOPPING_LIST_POPUP_PREFIX}-descriptionWrap`,
  description: `${SHOPPING_LIST_POPUP_PREFIX}-description`,
  btnWrap: `${SHOPPING_LIST_POPUP_PREFIX}-btnWrap`,
  btn: `${SHOPPING_LIST_POPUP_PREFIX}-btn`,
};
